export default __webpack_public_path__ + "static/media/img-slider-om-platform-1.59baa6ac.png";